import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import {
  clearMemoriesLocalSession,
  sanitizeLogoutReturnUrl,
} from '../utils/memoriesAuthBridge';

/**
 * Memories host: clear this origin's traveler/guest session, then return to
 * the main app (used when logging out from dejavunomad.com).
 * Storage-only — no React auth setState, so the main return page does not flash.
 */
const MemoriesLogoutClear = () => {
  const [params] = useSearchParams();
  const returnUrl = sanitizeLogoutReturnUrl(params.get('return'));

  useEffect(() => {
    clearMemoriesLocalSession();
    window.location.replace(returnUrl);
  }, [returnUrl]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="50vh"
      gap={2}
    >
      <CircularProgress size={36} />
      <Typography variant="body2" color="text.secondary">
        Signing you out…
      </Typography>
    </Box>
  );
};

export default MemoriesLogoutClear;
